import React, { FC } from 'react';
import { useFragment, gql } from '@apollo/client';
import BasketCategoriesList from './components/BasketCategoriesList/BasketCategoriesList';
import BasketUpsellSelections from './components/BasketUpsellSelections/BasketUpsellSelections';
// import BasketGreenSelection from './components/BasketGreenSelection';

import css from './BasketNewUpsell.module.scss';
import BasketSetsSelection from './components/BasketSetsSelection';
// import BasketGreenSelection from './components/BasketGreenSelection';
import { useBigSetBannerByPeriod } from './useBigSetBannerByPeriod';
import { BasketTopDishCard } from './components/BasketTopDishCard/BasketTopDishCard';

const BasketNewUpsell: FC = () => {
    const setName = useBigSetBannerByPeriod();

    const { data: menuDish } = useFragment({
        fragment: gql`
            fragment TOP_CARD_MENU_DISH on menuDish {
                id,
                price,
                portions,

            }
        `,
        from: {
            __ref: 'menuDish:5050',
        },
    });

    return (
        <div className={css.basketNewUpsellRoot}>
            <div className={css.basketUpsellTitle}>Добавить что-то</div>
            <BasketCategoriesList />
            {/* @ts-ignore */}
            <BasketUpsellSelections setName={setName} />
            {menuDish?.id
                ? <BasketTopDishCard id="5050" />
                : <BasketSetsSelection setName={setName} />
            }
        </div>
    );
};

export default BasketNewUpsell;
